/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useHistory, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_LOGOUT, API_SERVER, API_SCT, API_GET_PUBLIC } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
import LinesEllipsis from 'react-lines-ellipsis'
import TextareaAutosize from 'react-textarea-autosize';
import ReactPlayer from 'react-player/lazy'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Loading]
-------------------------------------------------------------------*/
import ReactLoading from 'react-loading';
/*------------------------------------------------------------------
[End Loading]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev, convertDateDBtoIndo } from '../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import OverlayBg from '../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Forum';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'forum';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [loading_stuck, set_loading_stuck] = useState(false);
    const [tour, set_tour] = useState(false);
    const [tab, set_tab] = useState(null);

    const [refresh, set_refresh] = useState(null);
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [table_height, set_table_height] = useState(0);

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [data_story, set_data_story] = useState(null);
    const [data_entry, set_data_entry] = useState(null);
    const [data_entry_populer, set_data_entry_populer] = useState(null);

    const [search, set_search] = useState('');
    const [search_public, set_search_public] = useState('');
    const [data_user_online, set_data_user_online] = useState(null);
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')
    const [name, set_name] = useState('')
    const [title, set_title] = useState('')
    const [entry, set_entry] = useState('')
    const [url, set_url] = useState('')
    const [type, set_type] = useState('')
    const [data_notification, set_data_notification] = useState(null);
    const [notification_count, set_notification_count] = useState(0);
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read_public = (pages) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_PUBLIC(`forum/entry/get/public__________?action=read_public_entry`
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev('response read public', response.data)
            if(response.data.result == 'success'){
                set_data_entry(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_public_populer = (pages) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_PUBLIC(`forum/entry/get/public__________?action=read_public_entry_populer`
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev('response read public populer', response.data)
            if(response.data.result == 'success'){
                set_data_entry_populer(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _search_public = () => {

        if(loading === true){
            return
        }
        
        if(search_public.length > 3){
    
            API_GET_PUBLIC(`forum/entry/get/public__________?action=search_public_entry`
                + '&search=' + search_public
            , 
            ).then((response) => {
                console_dev('response search', response.data)
                if(response.data.result == 'success'){
                    set_data_entry(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data_entry(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
            })

        }

    }

    const _uploads_entry = (params, storageUserParams) => {

        if(loading === true){
            return 
        }

		loading(true);

		API_POST('forum/entry/post__________', {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
            name: STORAGE_USER[0].name,
            uniquename: STORAGE_USER[0].uniquename, 
            title: title,
            entry: entry,
            url: url,
            url_photo: storageUserParams.path + '/' + storageUserParams.photo,
            type: type
		}).then((response) => {
            console_dev('response upload entry', response.data)
            if(response.data.result == 'success'){
                _read_public(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')
                set_name('')
                set_title('')
                set_entry('')
                set_url('')
                set_type('')
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _read_notification = (bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`forum/entry/get__________?action=read_notification`
            + '&bamboo_user=' + bambooUserParams
            // + '&slug=' + slug
        , 
		).then((response) => {
            console_dev('response read notification', response.data)
            if(response.data.result == 'success'){
                set_notification_count(response.data.data.count)
                set_data_notification(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

	}

    const _unread_notification = (bambooParams, bambooUserParams) => {

        if(loading === true){
            return
        }
        
        loading(true);

        API_GET_REQUEST(`forum/entry/get__________?action=unread_notification`
            + '&bamboo_update=' + bambooParams
            + '&bamboo_user=' + bambooUserParams
        , 
		).then((response) => {
            console_dev('response unread notification', response.data)
            if(response.data.result == 'success'){
                set_notification_count(response.data.data.count)
                set_data_notification(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

    }
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket_online = () => {

        socket.on("forum_user_authentication", (data) => {
			// console.log('forum_user_authentication : ', data)
            set_data_user_online(data)	
		})

        socket.emit("forum_user_authentication", {
            action: 'connect_public',
            room: 'room_forum_user_authentication',
            status: 'online_public',
            bamboo_user : random_character(16),
            username : random_character(16),
            name : random_character(16),
            e_account : 'e_forum',
        });
		
	}
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].bamboo;
            
            if(storage_bamboo){
                set_bamboo_user(storage_bamboo)
                _socket_online(STORAGE_USER[0])
                _read_public(1)
                _read_public_populer(1)
                _read_notification(storage_bamboo)
            }

        }else{
            _socket_online()
            _read_public(1)
            _read_public_populer(1)
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    // if(STORAGE_USER !== undefined){
    //     if(STORAGE_USER[0].level === 'guest'){
    //         history.push('/')
    //     }
    // }else{
    //     history.push('/home')
    //     window.location.reload();
    // }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search_public.length > 0){
            _search_public()
        }else{
            _STORAGE_USER()
        }

    }, [refresh, search_public])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 5)
        }

    }, [data])

    useEffect(() => {
        
        setTimeout(() => {
                
            set_loading_stuck(true) 
            
        }, 2500);

    }, [])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {

                !loading_stuck &&
                <div className="_app_loading">
                    <div className="_position_middle">
                        <ReactLoading type={'cylon'} color={'#222'} height={50} width={50} />
                        <h2 style={{marginBottom: 6}}><span style={{color: '#118ab2'}}>e-</span>Forum</h2>
                    </div>				
                </div>	
            
            }

            <div className="_forum_contaner">
                <div className="_forum_sidebar">
                    {
                        data_user_online && data_user_online.data.list.length > 0 ?
                            data_user_online.data.list.map((item, index) => (
                                <div key={index} className="_forum_sidebar_item" style={{backgroundImage: `url(${API_SERVER + '/' + item.url_photo})`}}>
                                    <div className="_forum_sidebar_item_bullet" style={{backgroundColor: item.status === 'offline' ? '#ddd' : null}}>
                                    </div>
                                    {
                                        item.url_photo === null &&
                                        item.name.charAt(0)
                                    }
                                </div>
                            ))
                        :
                            <div className="_forum_sidebar_item">
                                <div className="_forum_sidebar_item_bullet" style={{backgroundColor: '#ddd'}}>
                                </div>
                                +
                            </div>
                    }   
                </div>
                <div className="_forum_content">
                    <div className="_forum_navbar _lily_pad_h_d _push_t_d">
                        <div className="_row _center_align">
                            <div className="_column">
                                {/*  Search -------------------------------------------------------------------- */}
                                <div className="_bb_search">
                                    <div className="_row _center_align">
                                        <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                                        <div className="_column">
                                            <input 
                                                placeholder="Cari Diskusi" 
                                                onChange={e => set_search_public(e.target.value)}
                                                value={search_public}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/*  End Search ---------------------------------------------------------------- */}
                            </div>
                            <div>
                                <div className="_row">
                                    {
                                        STORAGE_USER !== undefined &&
                                        STORAGE_USER[0].e_account === 'e_forum' &&
                                        <>
                                            <div onClick={() => {
                                                if(element === 'overlay_dropdown_notification'){
                                                    set_element(null)
                                                }else{
                                                    set_element('overlay_dropdown_notification')
                                                }
                                            }}  className="_forum_profile _cursor_pointer">
                                                <ion-icon name="notifications-outline" style={{fontSize: 20}}></ion-icon>
                                                <div className="_forum_profile_bullet">
                                                    {
                                                        notification_count > 99 ?
                                                            '99+'
                                                        :
                                                            notification_count
                                                    }
                                                </div>
                                            </div>
                                            <div className="_relative">
                                                {
                                                    element === 'overlay_dropdown_notification' ?
                                                        // _left or _right
                                                        <>
                                                            <div className="_fmc_overlay_dropdown _right" style={{borderRadius: 16}}>
                                                                {
                                                                    data_notification && data_notification.list.length > 0 ?
                                                                        data_notification.list.map((item, index)=> (
                                                                            <div key={index} onClick={() => {
                                                                                _unread_notification(item.bamboo, item.bamboo_user)
                                                                                history.push(`/forum/${item.slug}`)
                                                                            }} className="_item _font_size_13px _left_text" style={{backgroundColor: item.unread === 'unread' ? null : '#f9f9fa'}}>{item.message}</div>
                                                                        ))
                                                                    :
                                                                        <div className="_item">Belum Ada Notifikasi</div>
                                                                }
                                                            </div>
                                                        </>
                                                    : null
                                                }
                                            </div>
                                        </>
                                
                                    }
                                    {
                                        STORAGE_USER !== undefined &&
                                        STORAGE_USER[0].e_account === 'e_forum' ?
                                            <NavLink 
                                                to='/'
                                                className="_forum_profile _cursor_pointer" 
                                            >
                                                <ion-icon name="person-circle-outline" style={{fontSize: 22}}></ion-icon>
                                            </NavLink>
                                        :  
                                            <NavLink 
                                                to='/forum/login'
                                                className="_forum_profile _cursor_pointer" 
                                            >
                                                <ion-icon name="finger-print-outline" style={{fontSize: 22}}></ion-icon>
                                            </NavLink>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="_container" style={{maxWidth: 1280}}>
                        <div className="_row_auto">
                            <div className="_column_auto">
                                {
                                    STORAGE_USER !== undefined &&
                                    STORAGE_USER[0].e_account === 'e_forum' &&
                                    <>
                                        <h2 style={{color: '#777', marginBottom: 4}}>Hi {STORAGE_USER[0].name},</h2>
                                        <h1 className="_push_b_m" style={{letterSpacing: 0}}>Diskusi Positif?</h1>
                                        <div className="_push_b_d">
                                            <div className="_e_input _push_b_m" style={{borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', borderRadius: 8, paddingLeft: 20, paddingRight: 20}}>
                                                <input 
                                                    placeholder="Judul"
                                                    type={'text'} 
                                                    onChange={e => set_title(e.target.value)}
                                                    value={title}
                                                />
                                            </div>
                                            {
                                                tab === 'text' &&

                                                <div className="_push_b_s">
                                                    <TextareaAutosize
                                                        className="_forum_entry_textarea"
                                                        minRows={3}
                                                        maxRows={6}
                                                        onChange={e => set_entry(e.target.value)}
                                                        value={entry}
                                                        placeholder={'Tulis Diskusi'}
                                                    />
                                                </div>
                                            }

                                            {
                                                tab === 'image' ?
                                                    <>
                                                        <div className="_push_b_s">
                                                            <TextareaAutosize
                                                                className="_forum_entry_textarea"
                                                                minRows={3}
                                                                maxRows={6}
                                                                onChange={e => set_entry(e.target.value)}
                                                                value={entry}
                                                                placeholder={'Tulis Diskusi'}
                                                            />
                                                        </div>
                                                        <div className="_e_input _push_b_m" style={{borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', borderRadius: 8, paddingLeft: 20, paddingRight: 20}}>
                                                            <input 
                                                                placeholder="Url Image"
                                                                type={'text'} 
                                                                onChange={e => set_url(e.target.value)}
                                                                value={url}
                                                            />
                                                        </div>
                                                    </>
                                                : tab === 'video' ?
                                                    <>
                                                        <div className="_push_b_s">
                                                            <TextareaAutosize
                                                                className="_forum_entry_textarea"
                                                                minRows={3}
                                                                maxRows={6}
                                                                onChange={e => set_entry(e.target.value)}
                                                                value={entry}
                                                                placeholder={'Tulis Diskusi'}
                                                            />
                                                        </div>
                                                        <div className="_e_input _push_b_m" style={{borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', borderRadius: 8, paddingLeft: 20, paddingRight: 20}}>
                                                            <input 
                                                                placeholder="Url Video"
                                                                type={'text'} 
                                                                onChange={e => set_url(e.target.value)}
                                                                value={url}
                                                            />
                                                        </div>
                                                    </>
                                                : tab === 'file' ?
                                                    <>
                                                        <div className="_push_b_s">
                                                            <TextareaAutosize
                                                                className="_forum_entry_textarea"
                                                                minRows={3}
                                                                maxRows={6}
                                                                onChange={e => set_entry(e.target.value)}
                                                                value={entry}
                                                                placeholder={'Tulis Diskusi'}
                                                            />
                                                        </div>
                                                        <div className="_e_input _push_b_m" style={{borderWidth: 1, borderColor: '#eee', borderStyle: 'solid', borderRadius: 8, paddingLeft: 20, paddingRight: 20}}>
                                                            <input 
                                                                placeholder="Url File"
                                                                type={'text'} 
                                                                onChange={e => set_url(e.target.value)}
                                                                value={url}
                                                            />
                                                        </div>
                                                    </>
                                                : null
                                            }
                                            <div className="_row _push_b_d _push_t_d _push_l_t">
                                                <div className="_push_r_d _cursor_pointer" onClick={() => {
                                                    set_type('text')
                                                    set_tab('text')
                                                }}>
                                                    <ion-icon name="text-outline" style={{fontSize: 20, color: tab === 'text' ? 'seagreen' : null}}></ion-icon>
                                                </div>
                                                <div className="_push_r_d _cursor_pointer" onClick={() => {
                                                    set_type('file')
                                                    set_tab('file')
                                                }}>
                                                    <ion-icon name="document-attach-outline" style={{fontSize: 20, color: tab === 'file' ? 'seagreen' : null}}></ion-icon>
                                                </div>
                                                <div className="_push_r_d _cursor_pointer" onClick={() => {
                                                    set_type('image')
                                                    set_tab('image')
                                                }}>
                                                    <ion-icon name="image-outline" style={{fontSize: 20, color: tab === 'image' ? 'seagreen' : null}}></ion-icon>
                                                </div>
                                                <div className="_push_r_d _cursor_pointer" onClick={() => {
                                                    set_type('video')
                                                    set_tab('video')
                                                }}>
                                                    <ion-icon name="play-outline" style={{fontSize: 20, color: tab === 'video' ? 'seagreen' : null}}></ion-icon>
                                                </div>
                                            </div>
                                            {
                                                STORAGE_USER !== undefined &&
                                                STORAGE_USER[0].e_account === 'e_forum' &&
                                                <div onClick={() => _uploads_entry('insert_entry', STORAGE_USER[0])} className="_btn _cursor_pointer" style={{borderColor: '#eee'}}>
                                                    Kirim
                                                </div>
                                            }
                                        </div>
                                    </>
                                }
                                {/* <h1 className="_push_b_d">Cerita Diskusi</h1>
                                <div className="_overflow_x _push_b_l">
                                    <div className="_forum_story_label">
                                        <div className="_forum_story_label_item">
                                            Terbaru
                                        </div>
                                        <div className="_forum_story_label_item">
                                            Populer
                                        </div>
                                        <div className="_forum_story_label_item">
                                            Rekomendasi
                                        </div>
                                    </div>
                                </div>
                                <div className="_overflow_x _push_b_l">
                                    <div className="_forum_story">
                                        <div className="_forum_story_item _push_r_d">
                                            <div className="_forum_story_item_circle">

                                            </div>
                                            <div className="_center_text _push_t_s _text_overflow _forum_story_item_text">
                                                Andika
                                            </div>
                                        </div>
                                        <div className="_forum_story_item _push_r_d">
                                            <div className="_forum_story_item_circle">

                                            </div>
                                            <div className="_center_text _push_t_s _text_overflow _forum_story_item_text">
                                                Name sadk askd kas 
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                <h1 className="_push_b_m">Diskusi Terbaru</h1>
                                {
                                    data_entry && data_entry.list.length > 0 ? 
                                        data_entry.list.map((item, index) => (
                                            <div key={index} className="_forum_entry _row _push_b_d">
                                                <div className="_forum_entry_profile _push_r_m" style={{backgroundImage: `url(${API_SERVER + '/' + item.url_photo})`}}>
                                                    {
                                                        item.url_photo === null &&
                                                        item.name.charAt(0)
                                                    }
                                                </div>
                                                <div className="_forum_entry_post _column">
                                                    <div className="_push_b_t">
                                                        {
                                                            <div className="_text_overflow" style={{borderRadius: 32}}>
                                                                <a style={{color: 'seagreen'}} href={item.url}> 
                                                                    {
                                                                        item.type === 'video' ?
                                                                            <ion-icon name="play-outline" style={{fontSize: 18, marginRight: 8, marginBottom: -4}}></ion-icon>
                                                                        : item.type === 'file' ? 
                                                                            <ion-icon name="document-outline" style={{fontSize: 18, marginRight: 8, marginBottom: -4}}></ion-icon>
                                                                        : item.type === 'image' ? 
                                                                            <ion-icon name="image-outline" style={{fontSize: 18, marginRight: 8, marginBottom: -4}}></ion-icon>
                                                                        : 
                                                                            <ion-icon name="text-outline" style={{fontSize: 18, marginRight: 8, marginBottom: -4}}></ion-icon>
                                                                    
                                                                    }
                                                                    {item.url}
                                                                </a>
                                                            </div>
                                                        }
                                                    </div>
                                                    <NavLink 
                                                        to={`/forum/${item.slug}`}>
                                                        <h3 className="_push_b_t">
                                                            <LinesEllipsis
                                                                text={decode(item.title)}
                                                                maxLine='2'
                                                                ellipsis='...'
                                                                trimRight
                                                                basedOn='letters'
                                                            />
                                                        </h3>
                                                        <p style={{fontSize: 11, fontFamily: 'Roboto-Medium', color: '#888'}}><span style={{color: '#555'}}>{decode(item.name)}</span> On {decode(convertDateDBtoIndo(item.year + '-' + item.month + '-' + item.today))}</p>
                                                        <LinesEllipsis
                                                            style={{fontSize: 11, fontFamily: 'Roboto-Medium', color: '#888'}}
                                                            text={decode(item.entry)}
                                                            maxLine='3'
                                                            ellipsis='...'
                                                            trimRight
                                                            basedOn='letters'
                                                        />
                                                        <div className="_row _push_t_s">
                                                            {
                                                                item.like_count > 0 &&
                                                                <div className="_forum_entry_like _push_r_m">
                                                                    <span style={{color: '#888', fontFamily: 'Roboto-Medium', fontSize: 10}}>Liked</span>
                                                                    <span className="_push_l_t" style={{color: '#888', fontSize: 10, fontFamily: 'Roboto-Medium'}}>{item.like_count > 99 ? '99+' : decode(item.like_count)}</span>
                                                                </div>
                                                            }
                                                            {
                                                                item.comment_count > 0 &&
                                                                <div className="_forum_entry_comment _push_r_m">
                                                                    <span style={{color: '#888', fontFamily: 'Roboto-Medium', fontSize: 10}}>Comment</span>
                                                                    <span className="_push_l_t" style={{color: '#888', fontSize: 10, fontFamily: 'Roboto-Medium'}}>{item.comment_count > 99 ? '99+' : decode(item.comment_count)}</span>
                                                                </div>
                                                            }
                                                        </div>
                                                    </NavLink>
                                                </div>
                                            </div>
                                        
                                        ))
                                    :
                                        data_entry &&
                                        <p>Belum Ada Entry</p>
                                }
                                {/*  Pagination ---------------------------------------------------------------- */}
                                <div className="_push_b_d">
                                    <div className="__pagination">
                                        {
                                            data_entry&&data_entry.pages.map((item, index) => {
                                                if(data_entry.pages.length > 1){
                                                    return (

                                                        <div 
                                                            key={index} 
                                                            className="__item"
                                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                                            onClick={() => {
                                                                _read_public(index + 1, bamboo_user);
                                                                set_pagination_active(index + 1)
                                                            }}
                                                        >
                                                            <div className="_position_middle">
                                                                {item}
                                                            </div>
                                                        </div>
                                                        
                                                    )
                                                }
                                            })
                                        }
                                    </div>
                                </div>
                                {/*  End Pagination -------------------------------------------------------------*/}

                            </div>

                            <div className="_column_auto">
                                {
                                    data_entry_populer && data_entry_populer.list.length > 0 ? 
                                        data_entry_populer.list.map((item, index) => (
                                            <div key={index} className="_forum_populer _push_b_d">
                                                <div style={{marginTop: 16, marginLeft: 8, marginRight: 8}}>
                                                    {
                                                        item.type === 'image' ?
                                                            <img style={{borderRadius: 12}} src={item.url} alt={item.slug}/>
                                                        : item.type === 'video' ?
                                                            <div className="_relative" style={{paddingTop: '56.25%'}}>
                                                                <ReactPlayer 
                                                                    style={{position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', borderRadius: 12, overflow: 'hidden'}}
                                                                    url={item.url}
                                                                    width='100%'
                                                                    height='100%'
                                                                />
                                                            </div>
                                                        : 
                                                            <div className="_text_overflow" style={{marginLeft: 8, marginRight: 8, borderRadius: 32}}>
                                                                <a style={{color: 'seagreen'}} href={item.url}> 
                                                                    {
                                                                        item.type === 'video' ?
                                                                            <ion-icon name="play-outline" style={{fontSize: 18, marginRight: 8, marginBottom: -4}}></ion-icon>
                                                                        : item.type === 'file' ? 
                                                                            <ion-icon name="document-outline" style={{fontSize: 18, marginRight: 8, marginBottom: -4}}></ion-icon>
                                                                        :  
                                                                            <ion-icon name="text-outline" style={{fontSize: 18, marginRight: 8, marginBottom: -4}}></ion-icon>
                                                                    
                                                                    }
                                                                    {item.url}
                                                                </a>
                                                            </div>
                                                    }
                                                </div>
                                                <NavLink 
                                                    to={`/forum/${item.slug}`}
                                                    className="_forum_populer_bottom" className="_cursor_pointer">
                                                    <div className="_forum_entry _row" style={{borderColor: 'transparent'}}>
                                                        <div className="_forum_entry_profile _push_r_m">
                                                            {decode(item.name.charAt(0))}
                                                        </div>
                                                        <div className="_forum_entry_post _column">
                                                            <h3 className="_push_b_t">
                                                                <LinesEllipsis
                                                                    text={item.title}
                                                                    maxLine='2'
                                                                    ellipsis='...'
                                                                    trimRight
                                                                    basedOn='letters'
                                                                />
                                                            </h3>
                                                            <p style={{fontSize: 11, fontFamily: 'Roboto-Medium', color: '#888'}}><span style={{color: '#555'}}>{item.name}</span> on {convertDateDBtoIndo(item.year + '-' + item.month + '-' + item.today)}</p>
                                                            <LinesEllipsis
                                                                style={{fontSize: 11, fontFamily: 'Roboto-Medium', color: '#888'}}
                                                                text={decode(item.entry)}
                                                                maxLine='3'
                                                                ellipsis='...'
                                                                trimRight
                                                                basedOn='letters'
                                                            />
                                                            <div className="_row _push_t_s">
                                                                {
                                                                    item.like_count > 0 &&
                                                                    <div className="_forum_entry_like _push_r_m">
                                                                        <span style={{color: '#888', fontFamily: 'Roboto-Medium', fontSize: 10}}>Liked</span>
                                                                        <span className="_push_l_t" style={{color: '#888', fontSize: 10, fontFamily: 'Roboto-Medium'}}>{item.like_count > 99 ? '99+' : decode(item.like_count)}</span>
                                                                    </div>
                                                                }
                                                                {
                                                                    item.comment_count > 0 &&
                                                                    <div className="_forum_entry_comment _push_r_m">
                                                                        <span style={{color: '#888', fontFamily: 'Roboto-Medium', fontSize: 10}}>Comment</span>
                                                                        <span className="_push_l_t" style={{color: '#888', fontSize: 10, fontFamily: 'Roboto-Medium'}}>{item.comment_count > 99 ? '99+' : decode(item.comment_count)}</span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </NavLink>
                                            </div>
                                        ))
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </>
    );

}

export default Screen;